import { FreePlansPage } from "../features";

export default FreePlansPage;
